export default __webpack_public_path__ + "1a5ab68be1a9c2c7b3b4aac30b7e308a.jpg";